import React from 'react';
import { InstagramIcon, FacebookIcon, MapPinIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-bg pt-16 pb-8 border-t border-brand-divider text-center" data-id="element-108">
      <div className="container px-4 flex flex-col items-center" data-id="element-109">
        <a href="#" className="font-playfair text-2xl font-semibold tracking-wide text-brand-text mb-8" data-id="element-110">
          Be Clinical
        </a>

        <nav className="flex flex-col md:flex-row items-center gap-6 md:gap-10 mb-10" data-id="element-111">
          {['Treatments', 'About', 'Results', 'FAQ', 'Contact'].map(item => <a key={item} href={`#${item.toLowerCase()}`} className="font-sans text-sm text-brand-text/70 hover:text-brand-gold uppercase tracking-widest transition-colors" data-id="element-112">
              {item}
            </a>)}
        </nav>

        <div className="flex items-center gap-6 mb-10" data-id="element-113">
          <a href="#" className="text-brand-text/50 hover:text-brand-gold transition-colors" aria-label="Instagram" data-id="element-114">
            <InstagramIcon className="w-5 h-5" data-id="element-115" />
          </a>
          <a href="#" className="text-brand-text/50 hover:text-brand-gold transition-colors" aria-label="Facebook" data-id="element-116">
            <FacebookIcon className="w-5 h-5" data-id="element-117" />
          </a>
        </div>

        <div className="flex flex-col items-center gap-2 text-brand-text/60 font-sans text-sm mb-12" data-id="element-118">
          <div className="flex items-center gap-2" data-id="element-119">
            <MapPinIcon className="w-4 h-4" data-id="element-120" />
            <span data-id="element-121">San Ramon, CA</span>
          </div>
          <a href="tel:+1234567890" className="hover:text-brand-gold transition-colors" data-id="element-122">
            (555) 123-4567
          </a>
        </div>

        <div className="w-full border-t border-brand-divider pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs font-sans text-brand-text/40" data-id="element-123">
          <p data-id="element-124">© {new Date().getFullYear()} Be Clinical. All rights reserved.</p>
          <div className="flex gap-4" data-id="element-125">
            <a href="#" className="hover:text-brand-text/70" data-id="element-126">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-brand-text/70" data-id="element-127">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}